export default {
  'FILTER' (state) {
    return state.filter
  },
  'FILTERS' (state) {
    return state.filters
  }
}
